import { FC } from 'react';
import styled from 'styled-components';
import colors from '../../../styles/colors';
import type { Wrestler } from '../../../types';


const SingleCardWrestler = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    background: ${colors.gradientBordeauxToBlack2};
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 4px;

    &:active {
        transform: scale(0.97);
        transition: transform 0.15s ease;
    }
`;

const BoxAvatarWrestler = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    aspect-ratio: 3 / 4;
    padding: 6px 4px 4px;

    & img.avatar-wrestler {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        object-fit: cover;
        object-position: top;
        border: 1px solid ${colors.bgColorBlack2};
    }
`;

const BoxNameWrestler = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 4px 4px 6px;

    & h6.name-wrestler {
        font-size: 11px;
        font-weight: 800;
        color: white;
        margin: 0;
        padding: 0;
        text-align: center;
        width: 100%;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
`;

interface SingleCardWrestlerMobileProps {
    wrestler: Wrestler;
    onClick: () => void;
}

const SingleCardWrestlerMobile: FC<SingleCardWrestlerMobileProps> = ({
    wrestler,
    onClick
}) => {
    return (
        <SingleCardWrestler
            onClick={onClick}
            className='single-card-wrestler'
        >
            <BoxAvatarWrestler className='box-avatar-wrestler'>
                <img src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name}
                    className='avatar-wrestler'
                />
            </BoxAvatarWrestler>

            <BoxNameWrestler className='box-name-wrestler'>
                <h6 className='name-wrestler'>{wrestler.name}</h6>
            </BoxNameWrestler>

        </SingleCardWrestler>
    )
}

export default SingleCardWrestlerMobile;
